import React, { FC, PropsWithChildren } from 'react';

import styles from './Main.module.css';

export const Main: FC<PropsWithChildren> = ({ children }) => {
  return <main className={styles.container}>{children}</main>;
};
